import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import { Socials } from '../Socials/Socials';


function About() {
  return (
    <Container fluid className='m-2 p-4 section-about'>
      <h2 className='text-white'>More About me</h2>

        <Card bg={"dark"} text='white' className="about-card" >
          <Card.Body>
            <Card.Text>
              {"I spent five years as the head of support for an e-commerce SAAS app, where I was introduced to and fell in love with web development. In 2022, I moved to a homestead where I could spend more time surrounded by nature. When I am not at work, I like to spend my time tinkering with IoT to automate my farm, spending time in my workshop (woodworking and blacksmithing), or going into the woods to practice bushcraft."}

          </Card.Text>
          <Socials />
        </Card.Body>

      </Card>
    </Container>
  );
}

export default About;